import { OwnUpHeader } from '@rategravity/own-up-component-library-legacy';
import React from 'react';

export const AuthHeader = () => {
  return (
    <OwnUpHeader variant="title">It&apos;s about the journey, not the destination...</OwnUpHeader>
  );
};
